export default "__VITE_ASSET__2c7b7ba8__"